import type {EnhancedStore} from '@reduxjs/toolkit';
import {configureStore} from '@reduxjs/toolkit';
import {initToastSagaMiddleware} from '@touchnet/react-toast';
import {initTnUserMgmtMiddleware} from '@touchnet/user-management';
import type {Persistor} from 'redux-persist';
import {
    FLUSH, PAUSE,
    PERSIST, PURGE,
    REGISTER, REHYDRATE,
    persistStore
} from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers/root-reducer';
import rootSaga from './sagas/root-saga';

const TnToastMiddleware = initToastSagaMiddleware();
const TnUserMgmtMiddleware = initTnUserMgmtMiddleware();

const init = (): { store: EnhancedStore; persistor: Persistor } => {
    const appSagas = createSagaMiddleware();

    const store = configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({
            serializableCheck: {
                getEntries: (value: object): Array<[string, unknown]> => Object.entries(value)
                    .filter(([key]: [string, unknown]) => key !== 'meta'),
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                    "terms/receiveAutoLoadedTerms",
                    "codes/updateOneCode"
                ],
            },
        }).concat(
            appSagas,
            TnToastMiddleware.middleware,
            TnUserMgmtMiddleware.middleware,
        ),
    });
    appSagas.run(rootSaga);
    TnToastMiddleware.run();
    TnUserMgmtMiddleware.run();

    const persistor: Persistor = persistStore(store);

    return {store, persistor};
};

export default init;
